import axios from 'axios'
import * as Redux from 'redux'
import { APIServices } from '@Services/api.service'
import { ToastServices } from '@Services/toast.service'
import SharedActions from '@Stores/shared/actions/loading.action'
import { InspectionActionTypes } from '../inspection.action-types'

const getInspectionForm = () => {
    return function (dispatch: Redux.Dispatch) {
        APIServices.axiosConfig()
        const url = `${APIServices.apiUrlV1}/admin/inspection/forms/general`
        axios.get(`${url}`).then((res) => {
            const { data } = res

            dispatch({
                type: InspectionActionTypes.GET_INSPECTION_FORM,
                payload: data,
            })
        })
    }
}

const createInspectionForm = (payload: any) => {
    return (dispatch: Redux.Dispatch) => {
        dispatch(SharedActions.setPageLoading(true) as any)
        APIServices.axiosConfig()
        return new Promise((resolve, reject) => {
            const url = `${APIServices.apiUrlV1}/admin/inspections/general`
            axios
                .post(url, payload)
                .then((response) => {
                    dispatch(SharedActions.setPageLoading(false) as any)
                    ToastServices.success('Inspection Created')
                    resolve(response)
                })
                .catch((errors) => {
                    dispatch(SharedActions.setPageLoading(false) as any)
                    const message = errors?.response?.data?.message
                    ToastServices.error(message || 'Unspecific errors!')
                    reject(errors)
                })
        })
    }
}

const getInspections = () => {
    return function (dispatch: Redux.Dispatch, getState: any) {
        APIServices.axiosConfig()
        const currentQueries =
            getState()?.inspection?.inspectionInfo?.inspectionQueries
        const inspectorId = currentQueries?.inspectorId
            ? { inspectorId: currentQueries?.inspectorId }
            : {}
        const params = {
            limit: 100,
            // inspectorId: '2110260000001',
            // ...currentQueries,
            ...inspectorId,
        }
        const url = `${APIServices.apiUrlV1}/admin/inspections`
        axios.get(`${url}`, { params }).then((res) => {
            const { data } = res.data
            if (data?.length) {
                dispatch({
                    type: InspectionActionTypes.GET_INSPECTION_DETAIL,
                    payload: data[0],
                })
            } else {
                dispatch({
                    type: InspectionActionTypes.GET_INSPECTION_DETAIL,
                    payload: null,
                })
            }
        })
    }
}
const getInspectionSchedules = () => {
    return function (dispatch: Redux.Dispatch, getState: any) {
        dispatch(SharedActions.setPageLoading(true) as any)
        APIServices.axiosConfig()
        const currentQueries =
            getState()?.inspection?.inspectionInfo?.inspectionQueries
        const inspectorId = currentQueries?.inspectorId
            ? { search: currentQueries?.inspectorId }
            : {}
        const params = {
            limit: 100,
            // inspectorId: '2110260000001',
            // ...currentQueries,
            ...inspectorId,
        }
        const url = `${APIServices.apiUrlV1}/admin/inspection/schedules`
        axios
            .get(`${url}`, { params })
            .then((res) => {
                setTimeout(() => {
                    dispatch(SharedActions.setPageLoading(false) as any)
                }, 500)
                const { data } = res.data
                if (data?.length) {
                    dispatch({
                        type: InspectionActionTypes.GET_INSPECTION_DETAIL,
                        payload: data[0],
                    })
                } else {
                    dispatch({
                        type: InspectionActionTypes.GET_INSPECTION_DETAIL,
                        payload: null,
                    })
                }
            })
            .catch((errors) => {
                dispatch(SharedActions.setPageLoading(false) as any)
                // const message = errors?.response?.data?.message
                // ToastServices.error(message || 'Unspecific errors!')
                // reject(errors)
            })
    }
}

const setInspectorQueries = (params?: any) => {
    return (dispatch: Redux.Dispatch, getState: any) => {
        const currentQueries =
            getState()?.inspection?.inspectionInfo?.inspectionQueries
        const payload = { ...currentQueries, ...params }

        dispatch({
            type: InspectionActionTypes.SET_INSPECTION_QUERIES,
            payload,
        })
    }
}

const InspectionInfoActions = {
    getInspectionForm,
    createInspectionForm,
    getInspections,
    getInspectionSchedules,
    setInspectorQueries,
}

export default InspectionInfoActions
